module.exports = __webpack_public_path__ + "static/media/WednesdaySpecial2x.5fcc1c99.png";